"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var useStyles = core_1.makeStyles(function () {
    return {
        toggleBtn: {
            cursor: 'pointer',
        },
    };
});
var NotificationCardFooter = function (props) {
    var isOpen = props.isOpen, needCollapse = props.needCollapse, toggleMessage = props.toggleMessage, created = props.created;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Grid, { container: true, justify: "space-between", alignItems: "flex-end" },
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.Typography, { variant: "caption" },
                react_1.default.createElement(react_intl_1.FormattedTime, { value: created }),
                " ",
                react_1.default.createElement(react_intl_1.FormattedDate, { value: created }))),
        needCollapse && (react_1.default.createElement(core_1.Grid, { item: true, className: classes.toggleBtn, onClick: toggleMessage },
            react_1.default.createElement(core_1.Typography, { className: "toggle-btn", variant: "caption" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: isOpen ? 'collapse' : 'expand' }))))));
};
exports.default = NotificationCardFooter;
